export default function NewsIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.60016 4.25347C7.79826 4.12454 9.58143 4 12 4C14.4223 4 16.2073 4.12492 17.4054 4.25408C18.1279 4.33195 18.6782 4.898 18.7418 5.6735C18.8655 7.18095 19 9.508 19 12.5C19 12.9002 18.9585 13.2294 18.8917 13.5H14.9985C13.0656 13.5 11.5 15.0651 11.5 16.9981V19.9982C9.33394 19.9825 7.71415 19.8664 6.60016 19.7465C5.87575 19.6686 5.32078 19.0987 5.2551 18.3181C5.13215 16.8572 5 14.6663 5 12C5 9.33369 5.13215 7.14283 5.2551 5.68187C5.32078 4.90133 5.87575 4.33144 6.60016 4.25347ZM12.5 19.8869C12.7649 19.7898 13.1035 19.6244 13.5124 19.3685C14.2149 18.929 14.9934 18.3068 15.7458 17.6043C16.4961 16.9039 17.1989 16.1438 17.7534 15.4423C18.0289 15.0938 18.2544 14.7763 18.4289 14.5H14.9985C13.6177 14.5 12.5 15.6175 12.5 16.9981V19.8869ZM4.25862 5.59802C4.36216 4.36765 5.26554 3.39133 6.49316 3.25922C7.72815 3.12631 9.54707 3 12 3C14.4567 3 16.2775 3.1267 17.5126 3.25984C18.7374 3.39186 19.6377 4.36396 19.7385 5.59172C19.8642 7.12374 20 9.47818 20 12.5C20 13.1339 19.9111 13.6631 19.7533 14.103C19.0037 16.1931 14.2205 21 12 21C9.54707 21 7.72815 20.8737 6.49316 20.7408C5.26554 20.6087 4.36216 19.6323 4.25862 18.402C4.13374 16.918 4 14.6988 4 12C4 9.30122 4.13374 7.08201 4.25862 5.59802ZM17 7.5L7 7.5V6.5L17 6.5V7.5ZM7 10.5L17 10.5V9.5L7 9.5V10.5ZM11 13.5H7V12.5H11V13.5ZM7 16.5H10V15.5H7V16.5Z"
          fill="white"
        />
      </svg>
    </>
  );
}
